import { DEFAULT, LIBRARY } from '../../types';

export default (state, action) => {
    switch (action.type) {
        case DEFAULT.SET_LOADING:
            return {
                ...state,
                loading: true
            };
        case DEFAULT.SET_LOADING_FALSE:
            return {
                ...state,
                loading: false
            };
        case DEFAULT.RESET_MESSAGE:
            return {
                ...state,
                response: '',
                responseType: ''
            };
        case DEFAULT.SET_HAS_CHANGED:
            return {
                ...state,
                hasChanged: 0
            };
        case LIBRARY.GET_REQUISITIONS:
            return {
                ...state,
                requisitions: action.payload
            };
        case LIBRARY.GET_LOANS:
            return {
                ...state,
                loans: action.payload
            };
        case LIBRARY.UPDATE_REQUISITION:
            return {
                ...state,
                response: action.payload,
                responseType: action.responseType,
                successiveActions: action.successiveActions,
                hasChanged: action.hasChanged
            };
        case LIBRARY.CANCEL_QUEUE:
            return {
                ...state,
                response: action.payload,
                responseType: action.responseType,
                successiveActions: action.successiveActions,
                hasChanged: action.hasChanged
            };
        case LIBRARY.GET_AWAITING_LIST:
            return {
                ...state,
                awaitingList: action.payload
            };
        case LIBRARY.GET_BOOK_BY_ID:
            return {
                ...state,
                book: action.payload
            };
        default:
            return state;
    }
};
